import styled from 'styled-components';
import { editable } from '@ubeya/shared-web/style';

//take styles from theme
export const TableAgGridWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .payroll-grid-table {
    .ag-overlay {
      z-index: 1;
    }

    .ag-header-cell-resize:after {
      opacity: 0;
    }

    .ag-tool-panel-horizontal-resize {
      display: none !important;
      pointer-events: none !important;
    }

    .ag-column-select-column-group .ag-column-select-column-group-drag-handle {
      display: none !important;
      pointer-events: none !important;
    }

    .ag-row-odd {
      background: ${({ theme }) => theme.colors.white};
    }

    .ag-root-wrapper {
      border-radius: 0;
      border-color: ${({ theme }) => theme.colors.grey2};
    }

    .ag-ltr .ag-cell,
    .ag-rtl .ag-cell {
      padding: 10px;
      line-height: normal;
      color: ${({ theme }) => theme.colors.black};
      font-size: 13px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
      border-right: 1px solid ${({ theme }) => theme.colors.grey2};
    }

    .ag-rtl .ag-cell {
      justify-content: flex-start;
    }

    .ag-row {
      border: none;
      ${editable}
    }

    .ag-header-cell-label {
      justify-content: flex-start;
    }

    .ag-header {
      background-color: ${({ theme }) => theme.colors.white};
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
    }

    .ag-header-cell {
      padding: 10px;
      border-right: 1px solid ${({ theme }) => theme.colors.grey2};
    }

    .ag-side-bar {
      border-left: 1px solid #e0e0e0;
    }

    .ag-row-group {
      background-color: ${({ theme }) => theme.colors.grey1};
      cursor: pointer;
    }

    .ag-floating-bottom-container .ag-row-pinned,
    .ag-pinned-right-floating-bottom .ag-row-pinned,
    .ag-pinned-left-floating-bottom .ag-row-pinned {
      background-color: ${({ theme }) => theme.colors.grey1} !important;
    }

    .ag-floating-bottom {
      border-top: none;
    }

    .ag-row-hidden {
      display: none !important;
    }

    .ag-ltr .ag-pinned-left-header,
    .ag-ltr .ag-pinned-left-cols-container,
    .ag-ltr .ag-pinned-left-floating-bottom {
      z-index: 1;
      box-shadow: rgba(0, 0, 0, 0.05) 5px 0px 7px;
    }

    .ag-rtl .ag-pinned-right-header,
    .ag-rtl .ag-pinned-right-cols-container,
    .ag-rtl .ag-pinned-right-floating-bottom {
      z-index: 1;
      box-shadow: rgba(0, 0, 0, 0.05) -5px 0px 7px;
    }

    .ag-ltr .ag-pinned-left-header,
    .ag-ltr .ag-cell-last-left-pinned {
      border-right: 1px solid ${({ theme }) => theme.colors.grey2} !important;
    }

    .ag-rtl .ag-pinned-right-header {
      border: none !important;
    }

    .ag-ltr .ag-pinned-right-header,
    .ag-ltr .ag-cell-first-right-pinned {
      border-left: 1px solid ${({ theme }) => theme.colors.grey2} !important;
    }

    .ag-rtl .ag-cell-last-left-pinned,
    .ag-rtl .ag-pinned-left-header {
      border-right: 1px solid ${({ theme }) => theme.colors.grey2} !important;
    }

    [col-id*='AutoColumn'] {
      display: none !important;
    }

    .cell-with-arrow > div {
      display: flex;
      gap: 4px;
    }

    /* Reset focus styles (START) */
    .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
    .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
    .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
    .ag-ltr .ag-cell-range-single-cell,
    .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
    .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
    .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
    .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
    .ag-rtl .ag-cell-range-single-cell,
    .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
      border-right: 1px solid ${({ theme }) => theme.colors.grey2} !important;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey2} !important;
    }
    /* Reset focus styles (END) */

    /* Row hover styles (START) */
    .ag-row-hover {
      background-color: rgb(225, 237, 255) !important;
    }
    .ag-row-hover::before,
    .ag-row:hover::before,
    .ag-row-hover::after,
    .ag-row:hover::after {
      display: none !important;
    }
    /* Row hover styles (END) */

    /* Hider for group headers (START) */
    .ag-header-row .ag-header-cell:not(.ag-header-span-height.ag-header-span-total) {
      border-top: none;
    }
    .ag-header-row.ag-header-row-column-group {
      display: none;
    }
    /* Hider for group headers (END) */
  }
`;
